// extracted by mini-css-extract-plugin
module.exports = {"MenuItem":"MenuItem_MenuItem_36Np6","MenuItem--inactive":"MenuItem_MenuItem--inactive_14NFi"};